import {Alert, Button, Col, Result, Row} from 'antd';
import React from 'react';
import SectionLayout from '../Layout/sectionLayout';
import {SmileOutlined} from '@ant-design/icons';
import {useNavigate} from 'react-router-dom';
import useLocalization from '../../../Localization';
const StayTunedComponent = () => {
  let navigate = useNavigate();
  const {ApplicationString} = useLocalization();
  return (
    <Result
      prefixCls='common-stay-tuned-container'
      icon={<SmileOutlined />}
      title={ApplicationString['stayTunedComponent.title']}
      extra={
        <Button
          type='primary'
          onClick={() => navigate('/')}
          prefixCls='common-stay-tuned-button'>
          {ApplicationString['stayTunedComponent.backHome']}
        </Button>
      }
    />
  );
};

export default StayTunedComponent;
